const DEMO_TEAM_ID = '8713e9d0-fbbc-4530-9f0a-99fdb16a9021'

export const isDemoTeam = (teamId: string) => {
  return teamId === DEMO_TEAM_ID
}
